import { useContext, useEffect } from 'react'

import { Box, IconsName, Spinner } from '@fairfashion/design-system'

import { ReportsCard } from './components/reports-card.comp'
import { ReportsContext, ReportsProvider } from './reports.context'
import { textInfo } from './reports.utils'

const ReportsComp = () => {
  const { reportsResume, loading, actions } = useContext(ReportsContext)

  useEffect(() => {
    actions.getReportsResume()
  }, [])

  return !loading ? (
    <Box direction="column" width="100%" gap={4} padding={3}>
      <Box gap={2} flexWrap="wrap">
        {reportsResume?.map((report, index) =>
          report.count > 0 ? (
            <ReportsCard
              key={index}
              title={textInfo(report.name)?.title}
              subtitle={textInfo(report.name)?.subtitle}
              counterTitle={textInfo(report.name)?.counterTitle}
              count={report.count}
              link={report.name}
              icon={textInfo(report.name)?.icon as IconsName}
            />
          ) : null,
        )}
      </Box>
    </Box>
  ) : (
    <Box width="100%" height="100%" justifyContent="center" alignItems="center">
      <Spinner />
    </Box>
  )
}

export const Reports = () => {
  return (
    <ReportsProvider>
      <ReportsComp />
    </ReportsProvider>
  )
}
